<script setup lang="ts">
import { PopoverAnchor, PopoverContent, PopoverRoot, PopoverTrigger } from "reka-ui";

const { search, autocomplete, isLoading, status, error } = useAutocomplete();
const { isDesktop } = useResponsive();
const { siteOptions } = useSiteOptions();

const isOpened = ref(false);
const showResults = computed(() => search.value.length > 0 && status.value !== "pending");

watch(showResults, (newValue) => isOpened.value = Boolean(newValue));

const icon = computed(() => {
  if (isLoading.value) {
    return "i-local-loading animate-spin";
  }
  return "i-local-search";
});

function handleSearch() {
  if (search.value.trim()) {
    window.location.href = `${siteOptions.value.shop_url}?search=${encodeURIComponent(search.value.trim())}`;
  }
}

function handleKeydown(event: KeyboardEvent) {
  if (event.key === "Enter") {
    event.preventDefault();
    handleSearch();
  }
}
</script>

<template>
  <div>
    <PopoverRoot v-model:open="isOpened">
      <PopoverAnchor class="relative flex items-center gap-4 mobile:p-4">
        <input v-model="search" type="search" placeholder="Rechercher..." class="input-search focus-hidden lg:focus-default w-0 grow rounded border-none bg-light p-4 text-lg font-medium text-primary placeholder:text-primary" @keydown="handleKeydown">
        <PopoverTrigger class="mobile:btn-scale-md desktop:btn-scale-lg z-sticky shrink-0 desktop:-ml-8" @click="handleSearch">
          <span class="size-6" :class="icon" />
        </PopoverTrigger>
      </PopoverAnchor>
      <PopoverContent side="bottom" :side-offset="isDesktop ? -32 : 0" align="start" sticky="partial" class="w-popover-autocomplete rounded-b bg-white text-dark shadow">
        <ul v-if="autocomplete.results.length > 0" class="">
          <li v-for="product in autocomplete.results" :key="product.product_id">
            <a :href="product.permalink" class="flex items-center gap-4 p-4 hover:text-primary">
              <img :src="product.image_url" class="size-16 shrink-0 object-cover " alt="">
              <h3 class="text-lg font-medium">
                {{ product.name }}
              </h3>
            </a>
          </li>
        </ul>
        <div v-else class="p-4">
          <h3 class="text-lg font-medium">
            {{ status === 'error' ? "Une erreur est survenue." : "Aucun résultat" }}
          </h3>
          {{ error }}
        </div>
      </PopoverContent>
    </PopoverRoot>
  </div>
</template>

<style lang="postcss">
.w-popover-autocomplete {
  width: calc(var(--reka-popover-trigger-width));
  @screen lg {
    width: calc(var(--reka-popover-trigger-width) - 32px);
}
}
</style>
